/**
 * Machine-readable error codes surfaced by the backend via
 * `error.extensions.code` on GraphQL errors. Values must match the backend
 * `ErrorCode` constants exactly (case-sensitive) — see TA-10121.
 */
export const ErrorCode = {
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  SUBSCRIPTION_REQUIRED: 'SUBSCRIPTION_REQUIRED',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
  CONFLICT: 'CONFLICT',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  RESULTS_TRUNCATED: 'RESULTS_TRUNCATED',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
